module.exports = __webpack_public_path__ + "img/loading.a6a055d2.gif";